import React from "react"
import AudioIcon from "./audio_icon"

const TermTitle = ({
  name,
  alt_name,
  audio_url,
  alt_audio_url,
  can_play
}) => (
  <div className="term-title">
    <div className="term__primary">
      {name}
      {!!audio_url &&
        <AudioIcon audio_url={audio_url} can_play={can_play} />}
    </div>
    {!!alt_name && alt_name !== name &&
      <div className="term__secondary">
        {alt_name}
        {!!alt_audio_url &&
          <AudioIcon audio_url={alt_audio_url} can_play={can_play} />}
      </div>}
  </div>
)

export default TermTitle
